import { gridSizeMdLg12, urlBackend } from "@/shared";
import { CustomTextFieldNoForm } from "@/shared/components/ui";
import { ScrollableDialogProps } from "@/shared/components/ui/Dialogs";
import { Alert, Grid } from "@mui/material";
import { useUpdateContratosDetalleFibra } from "../actions/reports-module.actions";
import { useState } from "react";
import { toast } from "react-toastify";
import { erpApi } from '@/shared/axios';
const { get, put } = erpApi();

export type DialogLiberarPuertoProps = {
    open: boolean;
    setOpen: (open: boolean) => void;
    dataPuerto: any;
    onSearch: () => Promise<boolean | undefined>;
};

const DialogLiberarPuerto: React.FC<DialogLiberarPuertoProps> = ({
    open,
    setOpen,
    dataPuerto,
    onSearch
}) => {
    const username = JSON.parse(localStorage.getItem("auth") || "{}")?.state?.user?.username;
    const handleClose = () => {
        setOpen(false);
    };

    const [formUpdate, setFormUpdate] = useState({
        idDetalleFibra: dataPuerto?.id_detalle_fibra,
        puerto_liberado: 'Liberado',
        username: username,
        puerto_nap: dataPuerto?.numero_puerto
    });

    const [isLoading, setIsLoading] = useState<boolean>(false);
    const useUpdateContratosDetalleFibraMutation = useUpdateContratosDetalleFibra();
    const ConfirmarLiberacion = async () => {

        if (formUpdate.puerto_nap == null || formUpdate.puerto_nap == '' || formUpdate.puerto_nap <= 0 || formUpdate.puerto_nap > 16) {
            toast.error("Por favor ingrese el número de puerto válido entre 1 y 16.");
            return false;
        }

        setIsLoading(true);
        useUpdateContratosDetalleFibraMutation.mutate(formUpdate as any, {
            onSuccess: async (response: any) => {
                // enviar a liberar api_nap
                // obtener data de la nap
                try {
                    const resp = await get<any[]>(
                        `${urlBackend}api/v1/nap/?nombre=${dataPuerto?.nombre_nap}&estado=true`,
                        true
                    ) as any;
                    if (resp?.data?.data?.length > 0) {
                        const data = resp.data.data[0];
                        let idNap = data.id_nap;
                        let jsonPuertos = data.puertos;

                        // buscar en el json el puerto formUpdate.puerto_nap y cambiarlo de estado.
                        // Puerto que queremos liberar
                        const puertoBuscado = Number(formUpdate.puerto_nap);

                        let idClienteContrato: string | null = null;
                        // Buscar y actualizar el puerto
                        jsonPuertos = jsonPuertos.map((item: any) => {
                            if (Number(item.puerto) === puertoBuscado) {
                                idClienteContrato = item.id_cliente_contrato;
                                return {
                                    ...item,
                                    estado: "DISPONIBLE",
                                    id_cliente_contrato: null
                                };
                            }
                            return item;
                        });

                        // Recalcular cantidades
                        const puertos_disponibles = jsonPuertos.filter(
                            (item: any) => item.estado === "DISPONIBLE"
                        ).length;

                        const puertos_ocupados = jsonPuertos.filter(
                            (item: any) => item.estado === "OCUPADO" || item.estado === "EN USO"
                        ).length;

                        // nuevo payload put
                        let updatePayload = {
                            'puertos': jsonPuertos,
                            'puertos_disponibles': puertos_disponibles,
                            'puertos_ocupados': puertos_ocupados
                        }

                        const respPut = await put<any[]>(
                            `${urlBackend}api/v1/nap/${idNap}/`,
                            updatePayload,
                            true
                        ) as any;
                        if (respPut?.code === 200) {
                            if (idClienteContrato != null) {
                                await put<any[]>(
                                    `${urlBackend}api/v1/contrato/${idClienteContrato}/`,
                                    { puerto: null },
                                    true
                                ) as any;
                            }
                            toast.success(response?.message || "Actualización de Nap realizado");
                        }

                    }
                    toast.success(response?.message || "Puerto Liberado Correctamente");
                    handleClose()
                    await onSearch()
                    setIsLoading(false);
                } catch (err) {
                    toast.error("Ocurrio un error en la liberación");
                    setIsLoading(false);
                }
            },
            onError: (error: any) => {
                if (error?.response?.data?.message) {
                    toast.error(error?.response?.data?.message);
                } else {
                    console.error('Error al procesar la informacion:', error);
                    toast.error('Error al procesar la información');
                }
                setIsLoading(false);
            }
        });
    }

    return (
        <>
            <ScrollableDialogProps
                open={open}
                title={"Confirmar Liberación de Puerto"}
                cancelTextBtn="Cancelar"
                confirmTextBtn="Confirmar Liberación"
                confirmBtnColor="success"
                confirmDisabled={isLoading}
                width="50%"
                contentNode={
                    <>
                        <Grid container spacing={3}>
                            <Grid item {...gridSizeMdLg12}>
                                Está a punto de liberar el siguiente recurso:
                            </Grid>
                            <CustomTextFieldNoForm
                                label="Nap"
                                defaultValue={dataPuerto?.nombre_nap}
                                disabled={true}
                                size={gridSizeMdLg12}
                            />
                            <CustomTextFieldNoForm
                                label="Puerto Nap - (Entre 1 y 16)"
                                defaultValue={formUpdate?.puerto_nap}
                                size={gridSizeMdLg12}
                                onChangeCustom={(valor) => {
                                    const value = valor.target.value;

                                    if (/^(|[1-9]\d*)$/.test(value)) {
                                        setFormUpdate({
                                            ...formUpdate,
                                            puerto_nap: value
                                        });
                                    }
                                }}
                                type="text"
                            />
                            <CustomTextFieldNoForm
                                label="Nombre Cliente"
                                defaultValue={dataPuerto?.nombre_cliente}
                                disabled={true}
                                size={gridSizeMdLg12}
                            />

                            <Grid item {...gridSizeMdLg12}>
                                <Alert
                                    severity="warning"
                                    variant="outlined"
                                    color='warning'
                                >
                                    La liberación solamente puede realizarse si está seguro de no afectar a un Cliente ACTIVO.
                                </Alert>
                            </Grid>
                        </Grid>
                    </>
                }
                onClose={handleClose}
                onConfirm={ConfirmarLiberacion}
            />
        </>
    );
};

export default DialogLiberarPuerto;